export interface OctopusTheme {
    "colorAvatarBackgroundActionDefault": string;
    "colorAvatarBackgroundActionHover": string;
    "colorAvatarBackgroundImageDefault": string;
    "colorAvatarBackgroundImageHover": string;
    "colorAvatarBackgroundPageDefault": string;
    "colorAvatarBackgroundPageHover": string;
    "colorAvatarBackgroundProjectDefault": string;
    "colorAvatarBackgroundProjectHover": string;
    "colorAvatarBackgroundSpaceDefault": string;
    "colorAvatarBackgroundSpaceHover": string;
    "colorAvatarBackgroundTemplateDefault": string;
    "colorAvatarBackgroundTemplateHover": string;
    "colorAvatarBackgroundTenantDefault": string;
    "colorAvatarBackgroundTenantHover": string;
    "colorAvatarBackgroundUserDefault": string;
    "colorAvatarBackgroundUserHover": string;
    "colorAvatarIconAction": string;
    "colorAvatarIconPage": string;
    "colorAvatarIconPrimary": string;
    "colorAvatarIconSecondary": string;
    "colorAvatarStackBackgroundHover": string;
    "colorAvatarStackBorder": string;
    "colorAvatarText": string;
    "colorBackgroundBold": string;
    "colorBackgroundDanger": string;
    "colorBackgroundDefault": string;
    "colorBackgroundDisabled": string;
    "colorBackgroundFeature": string;
    "colorBackgroundHover": string;
    "colorBackgroundInfo": string;
    "colorBackgroundInverseDanger": string;
    "colorBackgroundInverseFeature": string;
    "colorBackgroundInverseInfo": string;
    "colorBackgroundInverseNeutral": string;
    "colorBackgroundInverseNeutralQuiet": string;
    "colorBackgroundInversePrimary": string;
    "colorBackgroundInverseSecondary": string;
    "colorBackgroundInverseSuccess": string;
    "colorBackgroundInverseWarning": string;
    "colorBackgroundNeutral": string;
    "colorBackgroundPrimaryDefault": string;
    "colorBackgroundPrimaryHover": string;
    "colorBackgroundPrimaryPressed": string;
    "colorBackgroundPrimaryTransparent": string;
    "colorBackgroundQuartaryDefault": string;
    "colorBackgroundQuartaryHover": string;
    "colorBackgroundQuartaryPressed": string;
    "colorBackgroundSecondaryDefault": string;
    "colorBackgroundSecondaryHover": string;
    "colorBackgroundSecondaryPressed": string;
    "colorBackgroundSecondaryTransparent": string;
    "colorBackgroundSelected": string;
    "colorBackgroundSuccess": string;
    "colorBackgroundTertiary": string;
    "colorBackgroundWarning": string;
    "colorBadgeBoldBackgroundDanger": string;
    "colorBadgeBoldBackgroundFeature": string;
    "colorBadgeBoldBackgroundInfo": string;
    "colorBadgeBoldBackgroundInverseNeutral": string;
    "colorBadgeBoldBackgroundNeutral": string;
    "colorBadgeBoldBackgroundSuccess": string;
    "colorBadgeBoldBackgroundUpsell": string;
    "colorBadgeBoldBackgroundWarning": string;
    "colorBadgeBoldIconFeature": string;
    "colorBadgeBoldIconPrimary": string;
    "colorBadgeBoldIconSecondary": string;
    "colorBadgeBoldIconUpsell": string;
    "colorBadgeBoldTextFeature": string;
    "colorBadgeBoldTextPrimary": string;
    "colorBadgeBoldTextSecondary": string;
    "colorBadgeBoldTextUpsell": string;
    "colorBadgeSubtleBackgroundDanger": string;
    "colorBadgeSubtleBackgroundFeature": string;
    "colorBadgeSubtleBackgroundInfo": string;
    "colorBadgeSubtleBackgroundNeutral": string;
    "colorBadgeSubtleBackgroundSuccess": string;
    "colorBadgeSubtleBackgroundUpsell": string;
    "colorBadgeSubtleBackgroundWarning": string;
    "colorBadgeSubtleBorderDanger": string;
    "colorBadgeSubtleBorderFeature": string;
    "colorBadgeSubtleBorderInfo": string;
    "colorBadgeSubtleBorderNeutral": string;
    "colorBadgeSubtleBorderSuccess": string;
    "colorBadgeSubtleBorderUpsell": string;
    "colorBadgeSubtleBorderWarning": string;
    "colorBadgeSubtleIconDanger": string;
    "colorBadgeSubtleIconFeature": string;
    "colorBadgeSubtleIconInfo": string;
    "colorBadgeSubtleIconNeutral": string;
    "colorBadgeSubtleIconSuccess": string;
    "colorBadgeSubtleIconUpsell": string;
    "colorBadgeSubtleIconWarning": string;
    "colorBadgeSubtleTextDanger": string;
    "colorBadgeSubtleTextFeature": string;
    "colorBadgeSubtleTextInfo": string;
    "colorBadgeSubtleTextNeutral": string;
    "colorBadgeSubtleTextSuccess": string;
    "colorBadgeSubtleTextUpsell": string;
    "colorBadgeSubtleTextWarning": string;
    "colorBorderBold": string;
    "colorBorderDanger": string;
    "colorBorderDefault": string;
    "colorBorderDisabled": string;
    "colorBorderFeature": string;
    "colorBorderInfo": string;
    "colorBorderInversePrimary": string;
    "colorBorderInverseSecondary": string;
    "colorBorderLinkDefault": string;
    "colorBorderLinkHover": string;
    "colorBorderPrimary": string;
    "colorBorderSecondary": string;
    "colorBorderSelected": string;
    "colorBorderSuccess": string;
    "colorBorderTertiary": string;
    "colorBorderWarning": string;
    "colorButtonBackgroundDestructiveDefault": string;
    "colorButtonBackgroundDestructiveHover": string;
    "colorButtonBackgroundDestructivePressed": string;
    "colorButtonBackgroundDisabled": string;
    "colorButtonBackgroundGhostDefault": string;
    "colorButtonBackgroundGhostHover": string;
    "colorButtonBackgroundGhostPressed": string;
    "colorButtonBackgroundLoudDefault": string;
    "colorButtonBackgroundLoudHover": string;
    "colorButtonBackgroundLoudPressed": string;
    "colorButtonBackgroundNeutralDefault": string;
    "colorButtonBackgroundNeutralHover": string;
    "colorButtonBackgroundNeutralPressed": string;
    "colorButtonBackgroundPrimaryDefault": string;
    "colorButtonBackgroundPrimaryHover": string;
    "colorButtonBackgroundPrimaryPressed": string;
    "colorButtonBackgroundQuietDefault": string;
    "colorButtonBackgroundQuietHover": string;
    "colorButtonBackgroundQuietPressed": string;
    "colorButtonBackgroundSecondaryDefault": string;
    "colorButtonBackgroundSecondaryHover": string;
    "colorButtonBackgroundSecondaryPressed": string;
    "colorButtonBackgroundTertiaryDefault": string;
    "colorButtonBackgroundTertiaryHover": string;
    "colorButtonBackgroundTertiaryPressed": string;
    "colorButtonBorderDisabled": string;
    "colorButtonBorderSecondary": string;
    "colorButtonFocus": string;
    "colorButtonIconDestructive": string;
    "colorButtonIconDisabled": string;
    "colorButtonIconGhost": string;
    "colorButtonIconLoud": string;
    "colorButtonIconNeutral": string;
    "colorButtonIconPrimary": string;
    "colorButtonIconQuietDefault": string;
    "colorButtonIconQuietHover": string;
    "colorButtonIconQuietPressed": string;
    "colorButtonIconSecondary": string;
    "colorButtonIconTertiaryDefault": string;
    "colorButtonIconTertiaryHover": string;
    "colorButtonIconTertiaryPressed": string;
    "colorButtonTextDestructive": string;
    "colorButtonTextDisabled": string;
    "colorButtonTextGhost": string;
    "colorButtonTextLoud": string;
    "colorButtonTextNeutral": string;
    "colorButtonTextPrimary": string;
    "colorButtonTextQuietDefault": string;
    "colorButtonTextQuietHover": string;
    "colorButtonTextQuietPressed": string;
    "colorButtonTextSecondary": string;
    "colorButtonTextTertiaryDefault": string;
    "colorButtonTextTertiaryHover": string;
    "colorButtonTextTertiaryPressed": string;
    "colorCalloutBackgroundDangerDefault": string;
    "colorCalloutBackgroundDangerHover": string;
    "colorCalloutBackgroundDangerPressed": string;
    "colorCalloutBackgroundFeatureDefault": string;
    "colorCalloutBackgroundFeatureHover": string;
    "colorCalloutBackgroundFeaturePressed": string;
    "colorCalloutBackgroundInfoDefault": string;
    "colorCalloutBackgroundInfoHover": string;
    "colorCalloutBackgroundInfoPressed": string;
    "colorCalloutBackgroundSuccessDefault": string;
    "colorCalloutBackgroundSuccessHover": string;
    "colorCalloutBackgroundSuccessPressed": string;
    "colorCalloutBackgroundUpsell": string;
    "colorCalloutBackgroundWarningDefault": string;
    "colorCalloutBackgroundWarningHover": string;
    "colorCalloutBackgroundWarningPressed": string;
    "colorCalloutBorderDanger": string;
    "colorCalloutBorderDefault": string;
    "colorCalloutBorderFeature": string;
    "colorCalloutBorderInfo": string;
    "colorCalloutBorderSuccess": string;
    "colorCalloutBorderUpsell": string;
    "colorCalloutBorderWarning": string;
    "colorCalloutCodeBackground": string;
    "colorCalloutIconDanger": string;
    "colorCalloutIconFeature": string;
    "colorCalloutIconInfo": string;
    "colorCalloutIconSuccess": string;
    "colorCalloutIconWarning": string;
    "colorCalloutTextBody": string;
    "colorCalloutTextDanger": string;
    "colorCalloutTextFeature": string;
    "colorCalloutTextInfo": string;
    "colorCalloutTextSuccess": string;
    "colorCalloutTextWarning": string;
    "colorCanvasBackground": string;
    "colorCanvasPattern": string;
    "colorCardBackgroundPrimaryDefault": string;
    "colorCardBackgroundSecondaryDefault": string;
    "colorCardBackgroundSecondaryHover": string;
    "colorCardChartBackgroundDefault": string;
    "colorCardChartBackgroundHover": string;
    "colorCarouselBackgroundPrimary": string;
    "colorCarouselIconDefault": string;
    "colorCarouselIconHover": string;
    "colorCarouselIconSelected": string;
    "colorCarouselTextPrimary": string;
    "colorCategorySelectListBackgroundActive": string;
    "colorCategorySelectListBackgroundDefault": string;
    "colorCategorySelectListBackgroundHover": string;
    "colorCategorySelectListIconActive": string;
    "colorCategorySelectListIconDefault": string;
    "colorCategorySelectListIconHover": string;
    "colorCategorySelectListTextActive": string;
    "colorCategorySelectListTextHover": string;
    "colorChipBackgroundDanger": string;
    "colorChipBackgroundPrimary": string;
    "colorChipBackgroundSecondary": string;
    "colorChipBackgroundSuccessful": string;
    "colorChipBorderPrimary": string;
    "colorChipFilledBackgroundDanger": string;
    "colorChipFilledBackgroundInfo": string;
    "colorChipFilledBackgroundPrimary": string;
    "colorChipFilledBackgroundSecondary": string;
    "colorChipFilledBackgroundSuccess": string;
    "colorChipFilledBackgroundWarning": string;
    "colorChipFilledIconDanger": string;
    "colorChipFilledIconInfo": string;
    "colorChipFilledIconPrimary": string;
    "colorChipFilledIconSecondary": string;
    "colorChipFilledIconSuccess": string;
    "colorChipFilledIconWarning": string;
    "colorChipFilledTextDanger": string;
    "colorChipFilledTextInfo": string;
    "colorChipFilledTextPrimary": string;
    "colorChipFilledTextSecondary": string;
    "colorChipFilledTextSuccess": string;
    "colorChipFilledTextWarning": string;
    "colorChipIconInverse": string;
    "colorChipIconPrimary": string;
    "colorChipIconWarning": string;
    "colorChipOutlinedBorderDanger": string;
    "colorChipOutlinedBorderInfo": string;
    "colorChipOutlinedBorderPrimary": string;
    "colorChipOutlinedBorderSecondary": string;
    "colorChipOutlinedBorderSuccess": string;
    "colorChipOutlinedBorderWarning": string;
    "colorChipOutlinedIconDanger": string;
    "colorChipOutlinedIconInfo": string;
    "colorChipOutlinedIconPrimary": string;
    "colorChipOutlinedIconSecondary": string;
    "colorChipOutlinedIconSuccess": string;
    "colorChipOutlinedIconWarning": string;
    "colorChipOutlinedTextDanger": string;
    "colorChipOutlinedTextInfo": string;
    "colorChipOutlinedTextPrimary": string;
    "colorChipOutlinedTextSecondary": string;
    "colorChipOutlinedTextSuccess": string;
    "colorChipOutlinedTextWarning": string;
    "colorChipTextInverse": string;
    "colorChipTextPrimary": string;
    "colorCodeEditorBackground": string;
    "colorCodeEditorCodeActivelineBackground": string;
    "colorCodeEditorCodeAtomNumberKeywordVariableAttributeQuoteColor": string;
    "colorCodeEditorCodeBracketCommentColor": string;
    "colorCodeEditorCodeCursorBorderLeft": string;
    "colorCodeEditorCodeCursorBorderRight": string;
    "colorCodeEditorCodeDefTagBuiltinQualifierHeaderEmColor": string;
    "colorCodeEditorCodeErrorInvalidcharColor": string;
    "colorCodeEditorCodeFatCursorBackground": string;
    "colorCodeEditorCodeHint": string;
    "colorCodeEditorCodeHintActiveBackground": string;
    "colorCodeEditorCodeHintsBackground": string;
    "colorCodeEditorCodeIndentationMarkerActiveColor": string;
    "colorCodeEditorCodeIndentationMarkerColor": string;
    "colorCodeEditorCodeLinenumberColor": string;
    "colorCodeEditorCodeMatchingbracketColor": string;
    "colorCodeEditorCodePositiveColor": string;
    "colorCodeEditorCodePropertyColor": string;
    "colorCodeEditorCodePunctuationUnitNegativeColor": string;
    "colorCodeEditorCodeSelectedBackground": string;
    "colorCodeEditorCodeStringOperatorColor": string;
    "colorCodeEditorCodeSyntaxAtom": string;
    "colorCodeEditorCodeSyntaxAttributeName": string;
    "colorCodeEditorCodeSyntaxBool": string;
    "colorCodeEditorCodeSyntaxBracket": string;
    "colorCodeEditorCodeSyntaxClassName": string;
    "colorCodeEditorCodeSyntaxComment": string;
    "colorCodeEditorCodeSyntaxDeleted": string;
    "colorCodeEditorCodeSyntaxDeletedBackground": string;
    "colorCodeEditorCodeSyntaxEmphasis": string;
    "colorCodeEditorCodeSyntaxEscape": string;
    "colorCodeEditorCodeSyntaxHeading": string;
    "colorCodeEditorCodeSyntaxInvalid": string;
    "colorCodeEditorCodeSyntaxKeyword": string;
    "colorCodeEditorCodeSyntaxLink": string;
    "colorCodeEditorCodeSyntaxMeta": string;
    "colorCodeEditorCodeSyntaxName": string;
    "colorCodeEditorCodeSyntaxNumber": string;
    "colorCodeEditorCodeSyntaxOperator": string;
    "colorCodeEditorCodeSyntaxPropertyName": string;
    "colorCodeEditorCodeSyntaxQuote": string;
    "colorCodeEditorCodeSyntaxRegexp": string;
    "colorCodeEditorCodeSyntaxSpecialVariableName": string;
    "colorCodeEditorCodeSyntaxString": string;
    "colorCodeEditorCodeSyntaxStrong": string;
    "colorCodeEditorCodeSyntaxTagName": string;
    "colorCodeEditorCodeSyntaxTypeName": string;
    "colorCodeEditorCodeSyntaxTypeOperator": string;
    "colorCodeEditorCodeSyntaxUrl": string;
    "colorCodeEditorCodeSyntaxVariableName": string;
    "colorCodeEditorCodeVariable2Variable3String2UrlColor": string;
    "colorCodeEditorCodeVariableColor": string;
    "colorCodeEditorForeground": string;
    "colorCodeEditorSelection": string;
    "colorCodeEditorSelectionMatch": string;
    "colorCodeEditorTextDefault": string;
    "colorCodeEditorTextGutter": string;
    "colorCodeEditorTextHighlight": string;
    "colorCodeEditorTextHintHighlight": string;
    "colorCodeEditorToolbarBackground": string;
    "colorCodeEditorToolbarButtonHover": string;
    "colorCodeReviewBackgroundDangerDefault": string;
    "colorCodeReviewBackgroundDangerMuted": string;
    "colorCodeReviewBackgroundPrimaryDefault": string;
    "colorCodeReviewBackgroundPrimaryMuted": string;
    "colorCodeReviewBackgroundSuccessDefault": string;
    "colorCodeReviewBackgroundSuccessMuted": string;
    "colorCodeReviewTextDanger": string;
    "colorCodeReviewTextPrimary": string;
    "colorCodeReviewTextSuccess": string;
    "colorDeprecatedBackgroundWarning": string;
    "colorDeprecatedBorderWarning": string;
    "colorDeprecatedIconWarning": string;
    "colorDeprecatedTextWarning": string;
    "colorDialogBackgroundPrimary": string;
    "colorDialogBackgroundSecondaryDefault": string;
    "colorDialogBackgroundSecondaryUpsell": string;
    "colorDialogHelpPanelText": string;
    "colorFormLegendBackgroundHover": string;
    "colorFormLegendBackgroundRest": string;
    "colorFreezeStatusBorder": string;
    "colorFreezeStatusIcon": string;
    "colorHealthStatusBackgroundExecuting": string;
    "colorHealthStatusBackgroundFailure": string;
    "colorHealthStatusBackgroundNeutral": string;
    "colorHealthStatusBackgroundSuccess": string;
    "colorHealthStatusBackgroundWarning": string;
    "colorHealthStatusIconDefault": string;
    "colorHealthStatusIconInverse": string;
    "colorIconDanger": string;
    "colorIconDisabled": string;
    "colorIconFeature": string;
    "colorIconInfo": string;
    "colorIconInversePrimary": string;
    "colorIconInverseSecondary": string;
    "colorIconLinkDefault": string;
    "colorIconLinkHover": string;
    "colorIconPrimary": string;
    "colorIconSecondary": string;
    "colorIconSelected": string;
    "colorIconSuccess": string;
    "colorIconTertiary": string;
    "colorIconWarning": string;
    "colorLifecycleBackgroundPrimary": string;
    "colorLifecycleBorderDefault": string;
    "colorLifecycleIconPrimary": string;
    "colorLifecycleTextPrimary": string;
    "colorMenuListBackgroundActive": string;
    "colorMenuListBackgroundDefault": string;
    "colorMenuListBackgroundHover": string;
    "colorMenuListBorderPrimary": string;
    "colorMenuListIconPrimary": string;
    "colorMenuListTextHighlight": string;
    "colorMenuListTextPrimary": string;
    "colorMenuListTextSecondary": string;
    "colorNavButtonBackgroundActive": string;
    "colorNavButtonBackgroundDefault": string;
    "colorNavButtonBackgroundHover": string;
    "colorNavButtonBackgroundPressed": string;
    "colorNavButtonIconActive": string;
    "colorNavButtonIconDefault": string;
    "colorNavButtonIconHover": string;
    "colorNavButtonIconPressed": string;
    "colorNavListBackgroundActive": string;
    "colorNavListBackgroundDefault": string;
    "colorNavListBackgroundHover": string;
    "colorNavListIconActive": string;
    "colorNavListIconDefault": string;
    "colorNavListTextActive": string;
    "colorNavListTextDefault": string;
    "colorNavListTextHover": string;
    "colorNavTabBackgroundActive": string;
    "colorNavTabBackgroundHover": string;
    "colorNavTabBorderPrimary": string;
    "colorNavTabIconActive": string;
    "colorNavTabIconDefault": string;
    "colorNavTabIconHover": string;
    "colorNavTabTextActive": string;
    "colorNavTabTextDefault": string;
    "colorNavTabTextHover": string;
    "colorOverlayPrimary": string;
    "colorOverlaySecondary": string;
    "colorPaginationBackgroundActive": string;
    "colorPaginationBackgroundDefault": string;
    "colorPaginationBackgroundDisabled": string;
    "colorPaginationBackgroundHover": string;
    "colorPaginationIconActive": string;
    "colorPaginationIconDefault": string;
    "colorPaginationIconDisabled": string;
    "colorPaginationIconHover": string;
    "colorPaginationTextActive": string;
    "colorPaginationTextDefault": string;
    "colorPaginationTextDisabled": string;
    "colorPaginationTextHover": string;
    "colorParallelChipBackground": string;
    "colorParallelChipIcon": string;
    "colorPopoverBackgroundPrimary": string;
    "colorPopoverBackgroundSecondary": string;
    "colorPopoverInfoCircleBackgroundDefault": string;
    "colorPopoverInfoCircleBackgroundHover": string;
    "colorPopoverInfoCircleTextDefault": string;
    "colorPopoverInfoCircleTextHover": string;
    "colorPortalCardBackground": string;
    "colorPortalCardContentDisabled": string;
    "colorPortalCardContentText": string;
    "colorPortalChipBackground": string;
    "colorPortalLinkTextHover": string;
    "colorPortalLogoBackground": string;
    "colorPortalPopoverBackground": string;
    "colorProcessContainerBackgroundSelected": string;
    "colorProcessContainerBorderSelected": string;
    "colorProcessStepBackgroundErrorPrimary": string;
    "colorProcessStepBackgroundErrorSecondary": string;
    "colorProcessStepBackgroundErrorSelected": string;
    "colorProcessStepBackgroundHoverError": string;
    "colorProcessStepBackgroundHoverPrimary": string;
    "colorProcessStepBackgroundHoverSecondary": string;
    "colorProcessStepBackgroundHoverTertiary": string;
    "colorProcessStepBackgroundHoverWarning": string;
    "colorProcessStepBackgroundPrimaryDefault": string;
    "colorProcessStepBackgroundPrimarySelected": string;
    "colorProcessStepBackgroundSecondaryDefault": string;
    "colorProcessStepBackgroundWarningDefault": string;
    "colorProcessStepBackgroundWarningSecondary": string;
    "colorProcessStepBackgroundWarningSelected": string;
    "colorProcessStepBorderDefault": string;
    "colorProcessStepBorderDisabled": string;
    "colorProcessStepBorderErrorDefault": string;
    "colorProcessStepBorderErrorHover": string;
    "colorProcessStepBorderErrorSelected": string;
    "colorProcessStepBorderHover": string;
    "colorProcessStepBorderSelected": string;
    "colorProcessStepBorderWarningDefault": string;
    "colorProcessStepBorderWarningHover": string;
    "colorProcessStepBorderWarningSelected": string;
    "colorProcessStepIconDefault": string;
    "colorProcessStepIconErrorPrimary": string;
    "colorProcessStepIconErrorSecondary": string;
    "colorProcessStepIconWarningPrimary": string;
    "colorProcessStepIconWarningSecondary": string;
    "colorProcessStepTextDisabled": string;
    "colorProcessWrapperBackgroundPrimary": string;
    "colorProcessWrapperBackgroundSecondary": string;
    "colorProgressBackgroundLinear": string;
    "colorProgressBackgroundPrimary": string;
    "colorProgressBackgroundSecondary": string;
    "colorProgressForegroundCircular": string;
    "colorProgressForegroundLinear": string;
    "colorProgressTextInfo": string;
    "colorScrollbarBackground": string;
    "colorScrollbarHandle": string;
    "colorSearchBackgroundNotice": string;
    "colorSearchBackgroundResultHover": string;
    "colorSearchBackgroundResultPressed": string;
    "colorSpaceSwitcherBackgroundDefault": string;
    "colorSpaceSwitcherBackgroundHover": string;
    "colorSpaceSwitcherBackgroundPressed": string;
    "colorSpaceSwitcherBorderPrimary": string;
    "colorSpaceSwitcherIconDefault": string;
    "colorSpaceSwitcherTextDefault": string;
    "colorSpaceSwitcherTextHover": string;
    "colorSpaceSwitcherTextPressed": string;
    "colorStatusBadgeBackgroundHealthy": string;
    "colorStatusBadgeBackgroundNeutral": string;
    "colorStatusBadgeBackgroundUnhealthy": string;
    "colorStatusBadgeBackgroundWarning": string;
    "colorStatusBadgeIconDefault": string;
    "colorStatusBadgeIconInverse": string;
    "colorStatusBadgeTextInverse": string;
    "colorStatusBadgeTextPrimary": string;
    "colorSwitchBackgroundOffDefault": string;
    "colorSwitchBackgroundOffDisabled": string;
    "colorSwitchBackgroundOnDefault": string;
    "colorSwitchBackgroundOnDisabled": string;
    "colorSwitchForegroundOffDefault": string;
    "colorSwitchForegroundOffDisabled": string;
    "colorSwitchForegroundOnDefault": string;
    "colorSwitchForegroundOnDisabled": string;
    "colorSwitchIconActive": string;
    "colorSwitchOverlayOff": string;
    "colorSwitchOverlayOn": string;
    "colorTableBackgroundDangerDefault": string;
    "colorTableBackgroundDangerHover": string;
    "colorTableBackgroundSuccessDefault": string;
    "colorTableBackgroundSuccessHover": string;
    "colorTableHeaderBackground": string;
    "colorTableTextDanger": string;
    "colorTagBackground": string;
    "colorTagText": string;
    "colorTextDanger": string;
    "colorTextDisabled": string;
    "colorTextFeature": string;
    "colorTextFieldBorderActive": string;
    "colorTextFieldBorderDanger": string;
    "colorTextFieldBorderDefault": string;
    "colorTextFieldBorderDisabled": string;
    "colorTextFieldBorderHover": string;
    "colorTextFieldIconDisabled": string;
    "colorTextFieldIconPrimary": string;
    "colorTextFieldTextDanger": string;
    "colorTextFieldTextDisabled": string;
    "colorTextFieldTextPrimary": string;
    "colorTextFieldTextSecondary": string;
    "colorTextFieldTextSelected": string;
    "colorTextInfo": string;
    "colorTextInversePrimary": string;
    "colorTextInverseSecondary": string;
    "colorTextLinkDefault": string;
    "colorTextLinkHover": string;
    "colorTextPrimary": string;
    "colorTextSecondary": string;
    "colorTextSelected": string;
    "colorTextSuccess": string;
    "colorTextTertiary": string;
    "colorTextWarning": string;
    "shadowDrawer": string;
    "shadowExtraSmall": string;
    "shadowFocused": string;
    "shadowFocusedInset": string;
    "shadowLarge": string;
    "shadowLayoutPrimary": string;
    "shadowMedium": string;
    "shadowSmall": string;
}